export interface IProductModel {
    id: string;
    itemId: string;
    upc: string;
    name: string;
    fullName?: string;
    price: number;
    quantity: number;
    qty: number;
    quantityOrder: number;
    image: string;
    unitOfMeasure: string;
    pricePer: number;
    promoDescription: string;
    description: string;
    salesRank: number;
    aisleId: string;
    departmentName: string;
    aisleName: string;
    shelfName: string;
    showStrikeThrough: boolean;
    offerText: string;
    promoDescriptionVal: string;
    offerComplete: boolean;
    comment: string;
    comments: string;
    substitutionValue: string;
    substitutionPreference: string;
    promoType: string;
    promoTitle: string;
    basePrice: number;
    basePricePer: number;
    restrictedValue: number;
    maxPurchaseQty: number;
    previousPurchaseQty: number;
    unitQuantity: string;
    promoEndDate: string;
    promoText: string;
    displayEstimateText: string;
    displayUnitQuantityText: string;
    pastPurchased: boolean;
    inventoryAvailable: string;
    channelEligibility: object;
    fulfillmentStartTime?: string;
    fulfillmentEndTime?: string;
    fulfillmentStartTimeSaturday?: string;
    fulfillmentEndTimeSaturday?: string;
    fulfillmentStartTimeSunday?: string;
    fulfillmentEndTimeSunday?: string;
    itemRetailSect?: string;
    isPreOrderItem?: boolean;
    preOrderStartDate?: string;
    itemEffectiveStartDate?: string;
    itemEffectiveEndDate?: string;
    priceHighlight?: boolean;
    priceIndicator?: string;
    isCustomCake?: boolean;
    imageUrl?: string;
    containsAlcohol?: boolean;
    alcoholVolumePct?: number;
}

export interface ICouponModel {
    id: string;
    offerId: string;
    name: string;
    price: number;
    image: string;
    description: string;
    expiryDate: string;
    refineEndDate: string;
    offerComplete: boolean;
    brand: string;
    category: string;
    offerPrice: string;
    status: string;
    offerType: string;
    refineBrand: string;
    refineDescription: string;
    refineOfferPrice: string;
    regularPrice: string;
    usageTypeTxt: string;
    usageType: string;
    offerPgmLabel: string;
    imageId: string;
    couponID: string;
    ecomDescription: string;
    forUDescription: string;
    deliveryChannel?: string;
}

export interface IDealModel {
    id: string;
    title: string;
    description: string;
    promo: string;
    image: string;
    expiryDate: string;
    brand: string;
    category: string;
    status: string;
}

export class DealModel implements IDealModel {
    id: string;
    title: string;
    description: string;
    promo: string;
    image: string;
    expiryDate: string;
    brand: string;
    category: string;
    status: string;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export interface IDealUpdateModel {
    id: string;
    title: string;
    description: string;
    promo: string;
}

export class DealUpdateModel implements IDealUpdateModel {
    public id: string;
    public title: string;
    public description: string;
    public promo: string;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export class CouponModel implements ICouponModel {
    public id: string;
    public offerId: string;
    public name: string;
    public price: number;
    public image: string;
    public description: string;
    public expiryDate: string;
    public updBtnText: string = 'Added';
    public updBtnMode: boolean = true;
    public brand: string;
    public category: string;
    public offerPrice: string = '';
    public status: string;
    public deleted: boolean;
    public offerType: string;
    public offerTs: string;
    public endDate: string;
    public offerPgm: string;
    public refineBrand: string;
    public refineDescription: string;
    public refineOfferPrice: string;
    public refineEndDate: string;
    public offerComplete: boolean;
    public regularPrice: string;
    public usageTypeTxt: string;
    public usageType: string;
    public offerPgmLabel: string;
    public imageId: string;
    public couponID: string;
    public isClippable?: boolean;
    public ecomDescription: string;
    public forUDescription: string;
    public deliveryChannel?: string;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export class ProductModel implements IProductModel {
    public id: string;
    pid?: string;
    itemId: string;
    public upc: string;
    public name: string;
    public fullName?: string;
    public price: number;
    public quantity: number;
    public qty: number;
    public quantityOrder: number;
    public image: string;
    public imageUrl: string;
    public unitOfMeasure: string;
    public pricePer: number;
    public promoDescription: string;
    public description: string;
    public salesRank: number;
    public aisleId: string;
    public departmentName: string;
    public aisleName: string;
    public shelfName: string;
    public updBtnText: string = 'Update';
    public updBtnMode: boolean = true;
    public showStrikeThrough: boolean;
    public offerText: string;
    public promoDescriptionVal: string;
    public offerComplete: boolean;
    public comment: string;
    public comments: string;
    public substitutionValue: string;
    public substitutionPreference: string;
    public promoType: string;
    public promoTitle: string;
    public basePrice: number;
    public basePricePer: number;
    public restrictedValue: number;
    public maxPurchaseQty: number;
    public previousPurchaseQty: number;
    public unitQuantity: string;
    public promoEndDate: string;
    public promoText: string;
    public displayEstimateText: string;
    public displayUnitQuantityText: string;
    public pastPurchased: boolean;
    public inventoryAvailable: string;
    public channelEligibility: object;
    public isArProduct?: boolean;
    public isMtoProduct?: boolean;
    public multiCustomizations?:boolean;
    public inventoryQty?: number;
    public preparationTime?: number;
    public sellByWeight?: string;
    public displayType?: string;
    public averageWeightStr? : string;
    public averageWeight : any;
    public mtoText? : string;
    public sellerId?: string;
    public sellerName?: string;
    public productReview?: IProductReview;
    public mtoDisplyableTime?: string;
    public mtoTagText?: string;
    public eventTracking?: EventTracking;
    public isMarketplaceItem?: string;
    public snapEligible?: boolean;
    public isProductTrackingDisabled?: boolean;
    public featured?: boolean;
    public prop65WarningIconRequired?: boolean;
    public isCustomizable?: boolean;
    public serviceDeptNum?: string;
    public isCateringProduct?: boolean;
    public inStoreShoppingElig?: boolean;
    public triggerQuantity?: number;
    public requiresReturn? : boolean;
    public channelInventory? : object;
    public minWeight?: string;
    public maxWeight?: string;
    public adId?: number;
    public isPreOrderItem?: boolean;
    public preOrderStartDate?: string;
    public itemEffectiveStartDate?: string;
    public itemEffectiveEndDate?: string;
    constructor(data?: any) {
        Object.assign(this, data);
    }
    public dispItemPackageQty?: number;
    public dispItemPackageUOM?: string = 'ct';
    public dispItemSizeQty?: number;
    public dispUnitOfMeasure?: string;
    public incrementPriceList?: {weight: string, price: string}[]
    fulfillmentStartTime?: string;
    fulfillmentEndTime?: string;
    fulfillmentStartTimeSaturday?: string;
    fulfillmentEndTimeSaturday?: string;
    fulfillmentStartTimeSunday?: string;
    fulfillmentEndTimeSunday?: string;
    itemRetailSect?: string;
    public badges?: BadgeModel[];
    public labels?: LabelsModel[];
    public previousBasePrice?: number;
    public priceHighlight?: boolean;
    public priceIndicator?: string;
    public isCustomCake?: boolean;
    public containsAlcohol?: boolean;
    public alcoholVolumePct?: number;
}

export interface ProductGenericGridResponseModel {
    products?: ProductModel[];
    docs?: ProductModel[];
    offersData?: any;
    purchases?: ProductModel[];
}

export interface IProductUpdateModel {
    id: string;
    price: number;
    comment: string;
    substitutionValue: string;
    quantity: number;
}

export class ProductUpdateModel implements IProductUpdateModel {
    public id: string;
    public price: number;
    public comment: string;
    public substitutionValue: string;
    public quantity: number;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}


export interface ISortRule {
    field: string;
    direction: number;
    type: string;
    callback?: (a: ProductModel, s: SortModel) => void;
}
export interface ISort {
    field: string;
    rule: ISortRule[];
    label: any;
    selected?: boolean;
    sort_at: string;
}

export class SortModel implements ISort {
    public field: string;
    public label: any;
    public rule: ISortRule[];
    public selected?: boolean;
    public sort_at: string;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export interface ICarousel {
    type: string;
    //behaviour: String;
    userRestrictions: string;
    dataSource: any;
    apiPostBody: any;
    actionButton: string;
    isAuthorizedUser: boolean;
    buyItAgainPage: string;
}

export class CarouselModel implements ICarousel {
    public type: string;
    public dataDriven: string;
    public behaviour: string;
    public userRestrictions: string;
    public dataSource: any;
    public title: string;
    public apiPostBody: any;
    public actionButton: string;
    public aisleName: string;
    public sellerId: string;
    public hostName?: string;
    public isRecommended: boolean;
    public id: number;
    public maxNoOfProducts: number;
    public isAuthorizedUser: boolean;
    public buyItAgainPage: string;
    public pathwaysWidget?: any;
    public sellerType?: string;
    public badgePreference?: string;
    public badgeList?: string;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export interface IDealCarousel {
    // To be added
}

export class DealCarouselModel implements IDealCarousel {
    // To be added
    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export interface IAisleCategory {
    aisleId: string;
    aisleName: string;
    aislePath: string;
    fileReference: string;
}

export interface ArSubscriptionFrequency {
    unit: string;
    count: number;
    displayUnitSingular: string;
    displayUnitPlural: string;
}
export interface ArSubscriptionItem {
    fulfillmentDate: string;
    quantity: number;
    productId: string;
    replenishItem: boolean;
    subscriptionActive: boolean;
    frequency: ArSubscriptionFrequency;
}
export interface ArProductSubscription {
    customerId: string;
    arSavedTime: string;
    fulfillmentType: string;
    subscribedItems: ArSubscriptionItem[];
}

export interface IArSubscription {
    banner?: string; 
    customerUUID?: string;
    fulfillment?: IFulfillment; 
    isNewSnSUser?: boolean; 
    snsFrequencies?: IFreqObj[];     
    customerId?: string;
    arSavedTime?: string;
    fulfillmentType?: string;
    subscribedItems?: ArSubscriptionItem[];
    isCheckboxFirstTimeChecked?: boolean;
    showHeaderTooltip?: boolean;
}

export interface IDataConfig {
    subscriptionSource?: string;
    nextFulfillmentDate?: string;
    nextFulfillmentType?: string;
    modal: string,
    showModal: boolean,
    frequencies?: IFreqObj[],
    selectedFrequency?: string | number,
    product?: ProductModel,
    productId?: string,
    productName?: string,
    productFulfillDate?: string,
    errModalType?: string,
    prevIdToFocus: string,
    contents?: any;
    ecomDescription?: string;
}

export interface IFreqObj {
    unit: string;
    count: number;
    isDefault: boolean;
    displayFrequency: string;
}

export class AisleCategoryModel implements IAisleCategory {

    public aisleId: string;
    public aisleName: string;
    public aislePath: string;
    public fileReference: string;

    constructor(data?: any) {
        this.aisleId = data.id;
        this.aisleName = data.name;
        this.aislePath = data.pagePath;

        if (window.innerWidth < 768) {
            this.fileReference = data.imagePathMobile;
        } else {
            this.fileReference = data.imagePath;
        }

        // README: Updating category path url with current branch id
        const startPlaceHolder = this.aislePath.indexOf('.');
        const endPlaceHolder = this.aislePath.indexOf('.html');
        if (
            startPlaceHolder !== -1
            && endPlaceHolder !== -1
        ) {

            const branchId = window['AB']?.userInfo?.branchId;

            /*
            * README:
            * step 1 - from the link url get the substring between first dot and dot_html
            * step 2 - split string by dot into multiple elements and save into array
            * (second step is required because the substring might contain multiple structures separated by dot)
            * step 3 - the placeHolder we want to replace will always be at the end of the initial substring, before dot_html
            *
            * This way we make sure we dynamically target the piece of the url that we want to replace.
            */
            const placeHolderString = String(this.aislePath).substring(startPlaceHolder + 1, endPlaceHolder);
            const placeHolderElements = placeHolderString.split('.');
            const placeHolder = placeHolderElements[placeHolderElements.length - 1];

            // README: Make sure that we are updating a url that has an id and not something else
            if (!isNaN(Number(placeHolder))) {

                this.aislePath = String(this.aislePath).replace(placeHolder, branchId);
            }
        }
    }
}

export interface ICart {
    cartId: string;
    cartSource: 'ABS' | null;
    cartCategory: string;
    cartItems: ICartItem[];
    cartItemsList: ICartItem[];
    seller: {sellerId: string, sellerName: string};
}

export interface ICartItem {
}

export interface IDisplayableElements {
    estimateLabel: boolean;
    sponsoredLabel: boolean;
    itemNotAvailable: boolean;
    availableInStoreLabel: boolean;
    unattendedDeliveryLabel: boolean;
    mto: boolean;
    coupons: boolean;
    addToCart: boolean;
    scheduleNSave: boolean;
    buyItAgain?: boolean;
    starRating?: boolean;
    price?: boolean;
    viewSimilarItemsLink?: boolean;
    image?: boolean;
    title?: boolean;
    sellerInfo?: boolean;
    sellerTag?: boolean;
    prop65Title?: boolean;
    nestedFulfillment?: boolean;
    promoText?: boolean;
    snapEligible?: boolean;
    isLightWeightProduct?:boolean;
}

export interface IFulfillment {
    fulfillmentType: string;
    nextOrderFulfillmentDate: string;
}

export interface IFreqObj {
    unit: string;
    count: number;
    isDefault: boolean;
    displayFrequency: string;
}

export interface IProductReview {
    isReviewDisplayEligible?: boolean;
    avgRating?: string | '' | null;
    reviewCount?: string | '' | null;
    isReviewWriteEligible?: boolean;
    isForOnetimeReview?: boolean;
    reviewTemplateType?: string;
}

export interface IConfigObj{
    appName?: string;
    bannerDomain?: string;
    programType?: string;
    sellerId?: string;
    enableLazyImpressions?: boolean;
    enableProductCarouselABTest?: boolean;
    // DNF page cannot use FeatureFlags from authoring. Have override for values here.
    dnfFlagOverride?: { [key: string]: boolean }; 
    isLightWeightProduct?: boolean;
    applyDiscoveryStyles?: boolean;
}

export interface IStpprDataObj{
    carouselTitle?: string;
    pathwaysWidget?: any
    isRecommended?: boolean;
}

export interface EventTracking {
    adId?: string,
    vendorId?:string,
    campId?: string,
    beacons?:any;
}

export interface ISnsInfoObj {
    isChecked : boolean;
    selectedFrequency : number;
    isFirstTimeSnsSub : boolean;
    updateCart : boolean
}

export interface LoaderState {
    show: boolean;
}

export interface OfferDetailsData {
    savings?: string,
    regularPrice?: string,
    title?: string,
    description?: string,
    offerPgm?: string,
    offerType?: string,
    endDate?: string,
    deleted?: boolean,
    status?: string,
    disclaimer?: string,
    offerSubPgm?: string,
    offerId?: string,
    imageId?: string,
    offerProtoType?: string,
    continuity?: any,
    detail?: string;
    programSubType?: string;
}
export interface ICouponCarousel {
    carouselSource: string;
    carouselFilter: string;
    carouselOfferLimit: number;
}

export class CouponCarouselModel implements ICouponCarousel {
    public carouselSource: string;
    public carouselFilter: string;
    public carouselOfferLimit: number;
    public errorMessage: string;
    public carouselTitle: string;
    public carouselLinkLabel: string;
    public carouselLinkPath: string;
    public offerCarouselApiBased: boolean;
    public upc: string;
    public includePageName: string = '';
    public odpOfferId: string;
    public logoSVGCouponCarouseImageEnable?: boolean = false;
    public logoSVGCouponCarouseImage?: string = '';
    public modelConfigurationId?: string = '';
    public offers?: any = {};
    public calledBy?: string = '';
    public popup?: boolean;
    public popupType?: 'signedIn' | 'createAccount';

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export interface IGetZoneRequest {
    storeId?: string;
    zipcode?: string;
    banner?: string;
    channel?: string;
    fragment?: string;
    screenName?: string;
    zone?: string;
    cartItems?: { bpn: string }[];
    marketingCloudVisitorId?: string;
    deliveryTimeZone?: string;
  }

export interface Sortable {
    attribute:     string;
    name:          string;
    defaultValue?: boolean;
} 

export interface ShopCouponRefresh {
    id?: string;
    deleted?: boolean;
    status?: string;
}

export interface OffersData {
    departments: Record<string, Offers>;
    upcs: Record<string, Offers>;
}

export interface Offers {
    offers: Record<string, CouponModel>;
}

export interface IModifier {
    sortId: number;
    name: string;
    displayType: string;
    controlType: string;
    minSelect: number;
    maxSelect: number;
    options: IModifierOption[];
    stepperEnabled?: boolean;
}

export interface IModifierOption {
    sortId: number;
    upcId: string;
    name: string;
    displayType: string;
    isDefault: boolean;
    baseCalories: string;
    temperature?: string;
    price: number;
    channelInventory: object;
    isSelected?: boolean;
    isOOS?: boolean;
    qty?: number;
}

export interface IModifierSelectedOptionsPayload {
    id: string;
    price: string;
}

export interface IEstimatedTotalRequestPayload {
    bpn: string;
    price: string;
    quantity: number;
    selectedModifiers: IModifierSelectedOptionsPayload[]
}

export interface SelectedModifierAndOptions {
    [key: string]: IModifierOption[]
}

export interface BadgeModel {
    badgeName?: string;
    color?: string;
    isStrikethrough?: boolean;
    isBoldText?: boolean;
    icon?: string;
}

export interface LabelsModel {
    labelName?: string;
    accessibilityText?: string;
    replacePlaceholder?: boolean;
    isLabelAppOnly?: boolean;
}

export interface ModifierOptionUPCs {
    isValid: boolean;
    upcs: string[];
}

export interface QtyStepperOptions {
    ctaLabel?: string;
    quantity?: number;
    modifierOptionUPCs?: ModifierOptionUPCs;
    entryId?: number;
    isCustomizationEditFlow?: boolean;
    customizationEditSource?: string;
    comments?: string;
    options?: ICartModifierOption[];
    isValid?: boolean;
}

export interface ICartModifierOption {
    upcId: string;
    name?: string;
    price?: number;
    isAvailable?: boolean;
    isRequired?: boolean;
    qty?: number;
}

export interface CustomizationDetails {
    flowType?: string;
    src?: string;
    entryId?: number;
}

export interface CurrentOrderData {
  orderId: string
  deliveryDate: string
  fulfillmentType: string
  storeNumber: string
  banner: string
  orderItems: OrderItem[]
  reviewItems: ReviewItem[]
}

interface OrderItem {
  itemName: string
  itemDescription: string
  itemCode: string
  quantity: number
  quantityType: string
  itemTotal: string
  bpnNum: string
  isRestrictedItem: boolean
  currency: string
  isReplenishItem: boolean
  isArProduct: boolean
  displayType: string
  orderedWeight: string
  sellByWeightIndicator: string
  pickStatus: string
}

interface ReviewItem {
  itemDescription: string
  quantity: number
  itemTotal: string
  bpnNum: string
  subApprovalStatus: string
  displayType: string
  orderedWeight: string
  replacements: ReplacemenItem[]
  itemName: string
  orderedUpcId: string
}

interface ReplacemenItem {
  itemId: string
  itemDescription: string
  itemCode: string
  quantity: number
  itemPrice: any
  upcId: string
  entryId: number
  itemScanCode: string
  isSubstituted: boolean
  isRestrictedItem: boolean
  isReplenishItem: boolean
  isArProduct: boolean
  fulfilledWeight: string
  saveAsFutureSubPreference: boolean
  saveAsFutureSubPreferenceText: string
  bpnNum: string
}

export interface CustomizationData {
    bpn: string;
    name: string;
    items: Item[];
}

interface Item {
    preferences: string;
    lineId: string;
    customizations: Customization[];
}

interface Customization {
    type: string;
    minSelect: number;
    maxSelect: number;
    options: Option[];
}

interface Option {
    name: string;
    price: string;
    quantity: string;
    upcId: string;
    channelInventory: ChannelInventory;
}

interface ChannelInventory {
    delivery: string;
    pickup: string;
    instore: string;
    shipping: string;
}

export interface IMarketingTile {
  webCtaMarketing?: string;
  webCtaProps?: {
    ctaText?: string;
    ctaLink?: string;
    ctaAltText?: string;
    disclaimerText?: string;
    disclaimerAltText?: string;
    disclaimerCtaLink?: string;
    openNewTab?: string;
    contentHubProcessed?: boolean;
    disclaimerExternalBrowser?: string;
    showDisclaimer?: string;
    popup?: boolean;
    popupType?: 'signedIn' | 'createAccount';
  };
  marketingTileTitle: string;
  marketingTileSubtitle?: string;
  displayType: string;
  backgroundColor?: string;
  backgroundImg?: string;
  backgroundImgAltText?: string;
  fontColor?: string;
  badgeSetupType?: string;
  badgeTitle?: string;
  badgeBackgroundColor?: string;
  iconBackgroundImage?: string;
  iconImageAltText?: string;
  alignment?: string;
  eyebrow?: string;
}
